// Copyright (c) 2019 Deere & Company

import './index.scss';

import React, { Component } from 'react';
import AuthenticatedPage from '../app/common/components/authenticated-page';
import FunctionCodeMaintenance from './components/function-code-maintenance';
import PropTypes from 'prop-types';

class FunctionCodeMaintainencePage extends Component {

    state= {
        navParameter: '',
    }

    componentWillReceiveProps ( nextProps ) {

        if ( nextProps.location.state === 'functionCode' ) {

            this.setState( {
                navParameter: nextProps.location.state,
            } );

        }

    }

    updateReload = () => {

        this.setState( {
            navParameter: '',
        } );

    }

    render () {

        return (
            <AuthenticatedPage className="admin-page">
                <FunctionCodeMaintenance
                    reload={this.state.navParameter}
                    updateReload={this.updateReload}
                />
            </AuthenticatedPage>
        );

    }

}
FunctionCodeMaintainencePage.displayName = 'FunctionCodeMaintainencePage';
FunctionCodeMaintainencePage.propTypes = {
    location: PropTypes.object.isRequired,
};

export default FunctionCodeMaintainencePage;
